// extracted by mini-css-extract-plugin
export default {"soWhat":"SoWhat_soWhat__gUatL","header":"SoWhat_header__3pvgJ","text":"SoWhat_text__f6yfQ"};